import { IEditModifierContext } from './editModifierContext';

export enum EditModifierActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	CHANGE_NAME_OF_MODIFIER = 'CHANGE_NAME_OF_MODIFIER',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_INITIAL_IDS_RESTAURANT = 'SET_INITIAL_IDS_RESTAURANT',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: EditModifierActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditModifierContext['needRefetchData'];
	};
}

interface ISetAllData {
	type: EditModifierActionTypes.SET_ALL_DATA;
	payload: {
		modifierID: IEditModifierContext['modifierID'];
		type: IEditModifierContext['type'];
		isCreatedOnPos: IEditModifierContext['isCreatedOnPos'];
		filePath: IEditModifierContext['filePath'];
		nameOfModifier: IEditModifierContext['nameOfModifier'];
		description: IEditModifierContext['description'];
		initialIDSelectedCustomer: IEditModifierContext['initialIDSelectedCustomer'];
		posName: IEditModifierContext['posName'];
		externalId: IEditModifierContext['externalId'];
		articleNumber: IEditModifierContext['articleNumber'];
		initialIDsSelectedRestaurant: IEditModifierContext['initialIDsSelectedRestaurant'];
		hasSchedulePriority: IEditModifierContext['hasSchedulePriority'];
		activationSchedule: IEditModifierContext['activationSchedule'];
		deactivationSchedule: IEditModifierContext['deactivationSchedule'];
		translations: IEditModifierContext['translations'];
	};
}

interface IChangeLoaderStatus {
	type: EditModifierActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: IEditModifierContext['isLoading'];
	};
}

interface ISetFileId {
	type: EditModifierActionTypes.SET_FILE_ID;
	payload: {
		fileId: IEditModifierContext['fileId'];
	};
}

interface IDeletePhoto {
	type: EditModifierActionTypes.DELETE_PHOTO;
}

interface IChangeNameOfModifier {
	type: EditModifierActionTypes.CHANGE_NAME_OF_MODIFIER;
	payload: {
		nameOfModifier: IEditModifierContext['nameOfModifier'];
	};
}

interface IChangeDescription {
	type: EditModifierActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: IEditModifierContext['description'];
	};
}

interface ISetFetchedCustomers {
	type: EditModifierActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditModifierContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditModifierActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditModifierContext['IDSelectedCustomer'];
	};
}

interface IChangeExternalId {
	type: EditModifierActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: IEditModifierContext['externalId'];
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditModifierActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: IEditModifierContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: EditModifierActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditModifierContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditModifierActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditModifierContext['translations'];
	};
}

interface IToggleHasSchedulePriority {
	type: EditModifierActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: EditModifierActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditModifierContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditModifierActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditModifierContext['deactivationSchedule'];
	};
}

interface ISetFetchedRestaurants {
	type: EditModifierActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditModifierContext['fetchedRestaurants'];
	};
}

interface ISetInitialIDsRestaurant {
	type: EditModifierActionTypes.SET_INITIAL_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditModifierContext['IDsSelectedRestaurant'];
	};
}

interface ISetIDsRestaurant {
	type: EditModifierActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditModifierContext['IDsSelectedRestaurant'];
	};
}

interface ISetDataForSubmit {
	type: EditModifierActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditModifierContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditModifierContext['typeOfModalWindow'];
	};
}

export type TEditModifierAction =
	| IRefetchData
	| ISetAllData
	| IChangeLoaderStatus
	| ISetFileId
	| IDeletePhoto
	| IChangeNameOfModifier
	| IChangeDescription
	| ISetFetchedCustomers
	| ISetIDCustomer
	| IChangeExternalId
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedRestaurants
	| ISetInitialIDsRestaurant
	| ISetIDsRestaurant
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
